import { resolveHeaderTitle } from '../../lib/headerTitle';
import { usePageExperienceContext } from './usePageExperienceContext';

/**
 * The title the rendered header shows for the experience in context. For a
 * planner child that is the child's own title (the per-view header title),
 * falling back to the owning planner's title until the author sets one.
 *
 * Distinct from `useEffectiveExperience().title`, which is always the owning
 * planner's — that hook resolves the entity that owns shared state, not the
 * header's copy.
 */
export const useHeaderTitle = (): string => {
  const { experience, parentExperience } = usePageExperienceContext();

  return resolveHeaderTitle(experience, parentExperience);
};
